import { LobbyState, VideoCallState } from "../interfaces/videocallDtos/videoCall";

/**
 * Encodes LobbyState into a base64 token for URL transfer
 * @param state - LobbyState object to encode
 * @returns Base64 encoded string
 */
export const encodeLobbyStateToToken = (state: LobbyState): string => {
    try {
        const jsonString = JSON.stringify(state);
        return btoa(encodeURIComponent(jsonString));
    } catch (error) {
        console.error("Error encoding lobby state:", error);
        return "";
    }
};

/**
 * Decodes a token back to LobbyState
 * @param token - Base64 encoded token
 * @returns LobbyState object or null if decoding fails
 */
export const decodeTokenToLobbyState = (token: string | null | undefined): LobbyState | null => {
    if (!token) return null;
    try {
        const jsonString = decodeURIComponent(atob(token));
        return JSON.parse(jsonString) as LobbyState;
    } catch (error) {
        console.error("Error decoding lobby state token:", error);
        return null;
    }
};
/**
 * Encodes VideoCallState into a base64 token for URL transfer
 * @param state - VideoCallState object to encode
 * @returns Base64 encoded string
 */
export const encodeVideoCallStateToToken = (state: VideoCallState): string => {
    try {
        const jsonString = JSON.stringify(state);
        return btoa(encodeURIComponent(jsonString));
    } catch (error) {
        console.error("Error encoding video call state:", error);
        return "";
    }
};

/**
 * Decodes a token back to VideoCallState
 * @param token - Base64 encoded token
 * @returns VideoCallState object or null if decoding fails
 */
export const decodeTokenToVideoCallState = (token: string | null | undefined): VideoCallState | null => {
    if (!token) return null;
    try {
        const jsonString = decodeURIComponent(atob(token));
        return JSON.parse(jsonString) as VideoCallState;
    } catch (error) {
        console.error("Error decoding video call state token:", error);
        return null;
    }
};
